export default __webpack_public_path__ + "static/media/rtr-160-moto.11ba7c70.png";